//frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet, // <-- ДОБАВЛЕН ИМПОРТ
} from 'react-router-dom';
import { Box, Button } from '@mui/material'; // <-- ДОБАВЛЕН ИМПОРТ
import AppMUI from './AppMUI';
import HomeScreen from './screens/HomeScreen';
import ProjectsScreen2 from './screens/ProjectsScreen2';
import { Provider } from 'react-redux';
import store from './store';
import LoginScreen from './screens/LoginScreen';
import UsersScreen from './screens/UsersScreen';
import UserScreen from './screens/UserScreen';
import PrivateRoute from './components/PrivateRoute';
import ProfileScreen from './screens/ProfileScreen';
import UserRegisterScreen from './screens/UserRegisterScreen';
import NotFound from './screens/NotFound';
import AdminRoute from './components/AdminRoute';
import ProjectScreenV2 from './screens/ProjectScreenV2';
import ProjectEditScreenV2 from './screens/ProjectEditScreenV2';
import FunnelCorrectionScreen from './screens/FunnelCorrectionScreen';
import HistoryScreen from './screens/HistoryScreen';
import ReportsScreen from './screens/ReportsScreen';
import ReportScreen from './screens/ReportScreen';
import ReportSettingScreen from './screens/ReportSettingScreen';
import DirectoryScreen from './screens/DirectoryScreen';
import DirectoryItemScreen from './screens/DirectoryItemScreen';
import CorrectionScreen from './screens/CorrectionScreen';
import TasksScreen from './screens/TasksScreen';
import TaskScreen from './screens/TaskScreen';

// =======================================================
// 🤖 LAYOUT ДЛЯ МИНИ-ПРИЛОЖЕНИЯ БОТА (Без меню и шапок)
// =======================================================
const BotAppLayout = () => {
  return (
    <Box sx={{ width: '100%', height: '100vh', bgcolor: 'background.default', overflowX: 'hidden' }}>
      <Outlet />
    </Box>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<AppMUI />}>
      <Route path='/auth' element={<LoginScreen />} />
      <Route path='/profile' element={<ProfileScreen />} />

      {/* 🤖 ВЕТКА МИНИ-ПРИЛОЖЕНИЙ (доступна по прямой ссылке из бота) */}
      <Route path='/bot-app' element={<BotAppLayout />}>
        {/* Главное меню мини-приложения */}
        <Route index element={
          <Box p={3} textAlign="center">
            <h2>Главное меню DOMTAT</h2>
            <Button variant="contained" fullWidth sx={{ mb: 2 }}>Мои задачи</Button>
            <Button variant="contained" fullWidth sx={{ mb: 2 }}>Создать задачу</Button>
            <Button variant="outlined" fullWidth>Мои объекты</Button>
          </Box>
        } />
        {/* В будущем здесь будут:
        <Route path='tasks' element={<BotTasksList />} />
        <Route path='tasks/create' element={<BotTaskCreateScreen />} /> 
        */}
      </Route>

      <Route path='' element={<PrivateRoute />}>
        <Route index={true} path='/' element={<HomeScreen />} />
        <Route path='/news' element={<HistoryScreen />} />
        <Route path='/news/:page' element={<HistoryScreen />} />
        <Route path='/crm/:section' element={<ProjectsScreen2 />} />
        <Route path='/crm/:section/edit/:id' element={<ProjectEditScreenV2 />} />
        <Route path='/crm/:section/:id' element={<ProjectScreenV2 />} />
        {/* <Route path='/crm/:section/images/:id' element={<ProjectImagesScreen />} /> */}
        <Route path='/directories/:slug' element={<DirectoryScreen />} />
        <Route path='/directories/:slug/:id' element={<DirectoryItemScreen />} />
        <Route path='/tasks' element={<TasksScreen />} />
        <Route path='/tasks/:id' element={<TaskScreen />} />
        <Route path='/reports' element={<ReportsScreen />} />
        <Route path='/reports/:id' element={<ReportScreen />} />
        <Route path='/reports/:id/:settingsId' element={<ReportSettingScreen />} />
      </Route>

      <Route path='' element={<AdminRoute />}>
        <Route path='/crm/:section/:id/funnel-correction' element={<FunnelCorrectionScreen />} />
        <Route path='/correction' element={<CorrectionScreen />} />
        <Route path='/register' element={<UserRegisterScreen />} />
        <Route path='/users' element={<UsersScreen />} />
        <Route path='/users/:id' element={<UserScreen />} />
      </Route>

      <Route path='*' element={<NotFound />} />
    </Route>,
  ),
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
